routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.paymentCart', {
      url: "/pagos-y-anticipos/carrito de pagos",
      template: `<payment-cart sh-ctrl="shCtrl"></payment-cart>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-cart/payment-cart.config.js
 **/